<template>
    <div>
     <rdt-timer></rdt-timer>
     <v-card class="pa-2">
         <v-card-text><mrx-translation token="components.pages.intent.instructions"></mrx-translation></v-card-text>
         <v-card-actions><v-btn id="resend-intent" @click="intent()"><mrx-translation token="components.pages.intent.resend_intent"></mrx-translation></v-btn></v-card-actions>
     </v-card>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Intent',

        data() {
            return {}
        },

        created() {
            if (this.panel.options.autoLink) {
                this.intent()
            }
        },

        computed: {
            rdtTestMode() {
                return this.$store.getters['v4/mode/get']('rdtTestMode')
            },
            ...mapGetters({
                panel: 'v4/panel/current',
                track: 'v4/track/current'
            }),
        },

        methods: {
            async intent() {
                let bundle = await this.$store.dispatch('v4/collect/fhir')
                
                bundle = bundle.fhirThinkMD

                console.log(JSON.stringify(bundle, null, 2))

                let compressedBundle = await this.$store.dispatch('v4/xsz/base64urlEncode', JSON.stringify(bundle))
                let encodedBundle = encodeURIComponent(JSON.stringify(compressedBundle.data))

                let intent = `intent://${this.panel.options.host}/#Intent;`
                intent += this.panel.options.package ? `package=${this.panel.options.package};` : ''
                intent += this.panel.options.scheme ? `scheme=${this.panel.options.scheme};` : ''
                intent += this.panel.options.category ? `category=${this.panel.options.category};` : ''
                intent += this.panel.options.component ? `component=${this.panel.options.component};` : ''
                intent += `S.returnUrl=${encodeURIComponent(window.location.origin + '/#/track/'+ this.track.id + '/observation')};`
                intent += `S.fhirBundle=${encodedBundle};end`

                console.log(intent)
                window.location.href = intent
            },
            ...mapActions({
                nextLink: 'v4/navigate/nextLink'
            })
        }
    }
</script>
